import React from 'react';
import {
  buttonGrey,
  darkModeText,
  lightModeText,
  negativeRed,
  priceTagGreen,
} from "../util/style";
import { useAppContext } from "./AppContext";
import UpDownArrow from "./UpDownArrow";

const TickerPriceTag: React.FC = () => {
  const {
    darkMode,
    getFont,
    selectedTicker,
    lastClosePriceDelta,
    selectedTickerCurrency,
    lastPrice,
    prevClosePrice,
    numFormat,
    marketStatus,
    marketClosingPrice,
  } = useAppContext() || {};

  const useAfterMarket = ["PRE-MARKET", "AFTER-MARKET", "CLOSED"]?.includes(
    marketStatus?.title,
  );

  const dollarChange = lastClosePriceDelta || 0;

  const dollarChangeAfterMarket = useAfterMarket
    ? (lastPrice?.[selectedTicker] || 0) - (marketClosingPrice?.[selectedTicker] || 0)
    : 0;

  const percentChange =
    (100 * (lastClosePriceDelta || 0)) / (prevClosePrice?.[selectedTicker] || 1);

  const percentChangeAfterMarket = useAfterMarket
    ? (100 * ((lastPrice?.[selectedTicker] || 0) - (marketClosingPrice?.[selectedTicker] || 0))) /
      (prevClosePrice?.[selectedTicker] || 1)
    : 0;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        fontSize: getFont?.(12),
      }}
    >
      <div
        style={{
          margin: "0px auto 0px 0",
          fontWeight: "600",
          borderRadius: "0px",
          fontSize: getFont?.(14),
          color: darkMode ? darkModeText : lightModeText,
        }}
      >
        <span style={{}}>{selectedTicker}</span>
        <span style={{ marginLeft: "5px" }}>
          ${numFormat?.(lastPrice?.[selectedTicker] || 0)}
        </span>
        {selectedTickerCurrency && (
          <span style={{ marginLeft: "2px" }}>{selectedTickerCurrency}</span>
        )}
      </div>
      &nbsp;
      <div
        style={{
          padding: "0 3px 0 2px",
          margin: "0 0px 0 0",
          borderRadius: "0px",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          opacity: useAfterMarket ? "0.75" : "1",
          background:
            isNaN(dollarChange - dollarChangeAfterMarket) ||
            dollarChange - dollarChangeAfterMarket === 0
              ? buttonGrey
              : dollarChange - dollarChangeAfterMarket < 0
                ? negativeRed
                : priceTagGreen,
          color: "white",
        }}
      >
        <UpDownArrow
          number={dollarChange - dollarChangeAfterMarket}
          color={"white"}
        />
        <span style={{ marginLeft: "2px" }}>
          ${numFormat?.(Math.abs(dollarChange - dollarChangeAfterMarket))}
        </span>
      </div>
      {useAfterMarket && (
        <div
          style={{
            padding: "0 3px 0 2px",
            margin: "0 0px 0 0",
            borderRadius: "0px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            opacity: useAfterMarket ? "1" : "0.75",
            background:
              isNaN(dollarChangeAfterMarket) || dollarChangeAfterMarket === 0
                ? buttonGrey
                : dollarChangeAfterMarket < 0
                  ? negativeRed
                  : priceTagGreen,
            color: "white",
          }}
        >
          <UpDownArrow number={dollarChangeAfterMarket} color={"white"} />
          <span style={{ marginLeft: "2px" }}>
            ${numFormat?.(Math.abs(dollarChangeAfterMarket))}
          </span>
        </div>
      )}
      &nbsp;
      <div
        style={{
          padding: "0 3px 0 2px",
          margin: "0 0px 0 0",
          borderRadius: "0px",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          opacity: useAfterMarket ? "0.75" : "1",
          background:
            isNaN(percentChange - percentChangeAfterMarket) ||
            percentChange - percentChangeAfterMarket === 0
              ? buttonGrey
              : percentChange - percentChangeAfterMarket < 0
                ? negativeRed
                : priceTagGreen,
          color: "white",
        }}
      >
        <UpDownArrow
          number={percentChange - percentChangeAfterMarket}
          color={"white"}
        />
        <span style={{ marginLeft: "2px" }}>
          {numFormat?.(Math.abs(percentChange - percentChangeAfterMarket))}%
        </span>
      </div>
      {useAfterMarket && (
        <div
          style={{
            padding: "0 3px 0 2px",
            margin: "0 0px 0 0",
            borderRadius: "0px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            opacity: useAfterMarket ? "1" : "0.75",
            background:
              isNaN(percentChangeAfterMarket) || percentChangeAfterMarket === 0
                ? buttonGrey
                : percentChangeAfterMarket < 0
                  ? negativeRed
                  : priceTagGreen,
            color: "white",
          }}
        >
          <UpDownArrow number={percentChangeAfterMarket} color={"white"} />
          <span style={{ marginLeft: "2px" }}>
            {numFormat?.(Math.abs(percentChangeAfterMarket))}%
          </span>
        </div>
      )}
    </div>
  );
};

export default TickerPriceTag;
